import axios from "axios";
import Trigger from "../../validations/es6/plugins/Trigger";
import Bootstrap from "../../validations/es6/plugins/Bootstrap";
import SubmitButton from "../../validations/es6/plugins/SubmitButton";
import Declarative from "../../validations/es6/plugins/Declarative";
import Sequence from "../../validations/es6/plugins/Sequence";
import { getCookie } from "../../jwt/_helpers/cookie";
import { getValidationMessage } from "../../utils/i18nHelper";

import musicLinksValidationEN from "../../locales/en/musicLinksValidation";
import musicLinksValidationDE from "../../locales/de/musicLinksValidation";
import musicLinksValidationES from "../../locales/es/musicLinksValidation";
import musicLinksValidationFR from "../../locales/fr/musicLinksValidation";
import musicLinksValidationIT from "../../locales/it/musicLinksValidation";
import musicLinksValidationHR from "../../locales/hr/musicLinksValidation";
import musicLinksValidationNL from "../../locales/nl/musicLinksValidation";
import musicLinksValidationPT from "../../locales/pt/musicLinksValidation";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const validUrlRegex = /^(?:https?|http):\/\/(?:[^\s\/]+\.)?[^\s\/]+\.[^\s\/]+(?:\/[^\/\s]*)*$/;

const amazonUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?(?:amazon\.[a-z.]+|music\.amazon\.[a-z.]+)\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const appleMusicUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?music\.apple\.com\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const beatportUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?beatport\.com\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const deezerUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?deezer\.com\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const spotifyUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?open\.spotify\.com\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const traxsourceUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?traxsource\.com\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const youtubeUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?youtube\.com\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const tidalUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?(?:tidal\.com|listen\.tidal\.com)(?:\/[^\s\/]*)*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const soundCloudUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?soundcloud\.com\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;
const junoDownloadUrlRegex = /^(?:https?|http):\/\/(?:[a-z]+\.)?junodownload\.com\/[^\s\/]*(?:\/[^\/\s]*)*(?:\?[^\/\s]*)?$/;


export const validationMessages = {
  en: musicLinksValidationEN.update,
  de: musicLinksValidationDE.update,
  es: musicLinksValidationES.update,
  fr: musicLinksValidationFR.update,
  it: musicLinksValidationIT.update,
  hr: musicLinksValidationHR.update,
  nl: musicLinksValidationNL.update,
  pt: musicLinksValidationPT.update,
};

const createValidationOptions = (lang) => {
  return {
    fields: {
        release_name: {
            validators: {
              notEmpty: {
                message: getValidationMessage(validationMessages, 'release_name', 'required', lang)
              },
            }
          },
        ean: {
            validators: {
              notEmpty: {
                message: getValidationMessage(validationMessages, 'ean', 'required', lang)
              },
            }
        },
        artist_name: {
          validators: {
            notEmpty: {
              message: getValidationMessage(validationMessages, 'artist_name', 'required', lang)
            },
          }
        },
        url_part1: {
          validators: {
            notEmpty: {
              message: getValidationMessage(validationMessages, 'url_part1', 'required', lang)
            },
          }
        },
        url_part2: {
            validators: {
              notEmpty: {
                message: getValidationMessage(validationMessages, 'url_part2', 'required', lang)
              },
              stringLength: {
                min: 0,
                max: 10,
                message: getValidationMessage(validationMessages, 'url_part2', 'length', lang),
              },
              promise: {
                message: getValidationMessage(validationMessages, 'url_part2', 'duplicate', lang),
                promise: function(urlPartTwo) {
                  return new Promise(function(resolve, reject) {
                    let urlPartOne = document.getElementById("updateMusicLinkForm").querySelector('[name="url_part1"]').value || "";
                    let urlPartTwoInitial = document.getElementById("updateMusicLinkForm").querySelector('[name="url_part2_initial"]').value || "";
                    if(urlPartTwo.value !== "" && urlPartTwo.value !== urlPartTwoInitial) {
                      const token = getCookie("token");
                      const requestBody = {
                        url_part1: urlPartOne,
                        url_part2: urlPartTwo.value,
                      };
                      axios({
                        method: "POST",
                        mode: 'cors',
                        url: `${API_URL}musiclinks_urlparts/validate-urlparts/`,
                        data: requestBody,
                        headers: {
                          Authorization: `Bearer ${token}`,
                          "x-api-key": X_API_KEY,
                        }
                      }).then(function(response) {
                        if (response.status === 200) {
                          const valid = response.data.valid;
                          const message = response.data.status;
      
                          valid ? resolve({ valid: true, message: getValidationMessage(validationMessages, 'url_part2', 'urlAvailable', lang) }) : resolve({ valid: false, message: message });
                        } else {
                          reject({valid: false, message: getValidationMessage(validationMessages, 'url_part2', 'urlInvalid', lang)});
                        }
                      });
                    }
                    else {
                      resolve({ valid: true, message: getValidationMessage(validationMessages, 'url_part2', 'urlAvailable', lang) })
                    }
                  });
                }
              },
            }
          },
          amazonmusic_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'amazonmusic_url', 'required', lang)
                },
                regexp: {
                    regexp: amazonUrlRegex,
                    message: getValidationMessage(validationMessages, 'amazonmusic_url', 'invalid', lang),
                },
            }
        },
        applemusic_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'applemusic_url', 'required', lang)
                },
                regexp: {
                    regexp: appleMusicUrlRegex,
                    message: getValidationMessage(validationMessages, 'applemusic_url', 'invalid', lang),
                },
            }
        },
        beatport_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'beatport_url', 'required', lang)
                },
                regexp: {
                    regexp: beatportUrlRegex,
                    message: getValidationMessage(validationMessages, 'beatport_url', 'invalid', lang),
                },
            }
        },
        deezer_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'deezer_url', 'required', lang)
                },
                regexp: {
                    regexp: deezerUrlRegex,
                    message: getValidationMessage(validationMessages, 'deezer_url', 'invalid', lang),
                },
            }
        },
        junodownload_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'junodownload_url', 'required', lang)
                },
                regexp: {
                    regexp: junoDownloadUrlRegex,
                    message: getValidationMessage(validationMessages, 'junodownload_url', 'invalid', lang),
                },
            }
        },
        soundcloud_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'soundcloud_url', 'required', lang)
                },
                regexp: {
                    regexp: soundCloudUrlRegex,
                    message: getValidationMessage(validationMessages, 'soundcloud_url', 'invalid', lang),
                },
            }
        },
        spotify_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'spotify_url', 'required', lang)
                },
                regexp: {
                    regexp: spotifyUrlRegex,
                    message: getValidationMessage(validationMessages, 'spotify_url', 'invalid', lang),
                },
            }
        },
        tidal_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'tidal_url', 'required', lang)
                },
                regexp: {
                    regexp: tidalUrlRegex,
                    message: getValidationMessage(validationMessages, 'tidal_url', 'invalid', lang),
                },
            }
        },
        traxsource_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'traxsource_url', 'required', lang)
                },
                regexp: {
                    regexp: traxsourceUrlRegex,
                    message: getValidationMessage(validationMessages, 'traxsource_url', 'invalid', lang),
                },
            }
        },
        youtube_url: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'youtube_url', 'required', lang)
                },
                regexp: {
                    regexp: youtubeUrlRegex,
                    message: getValidationMessage(validationMessages, 'youtube_url', 'invalid', lang),
                },
            }
        },
        other_url: {
            validators: {
                regexp: {
                    regexp: validUrlRegex,
                    message: getValidationMessage(validationMessages, 'other_url', 'invalid', lang),
                },
            }
        },
    },
    plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap(),
        submitButton: new SubmitButton(),
        declarative: new Declarative({
          html5Input: true
        }),
        sequence: new Sequence({
          enabled: true
        }),
    }
  };
};

export { createValidationOptions };